import { observable } from "@legendapp/state";
import { persistObservable } from "@legendapp/state/persist";
import { ObservablePersistSessionStorage } from "@legendapp/state/persist-plugins/local-storage";
import {
  Nationality,
  PassengerStoreType
} from "@website/store/store/store.types";

export const passengerInfoDefault = {
  mainPassengerName: "",
  mainPassengerFamily: "",
  mainPassengerNationality: Nationality.Iranian,
  mainPassengerNationalCode: "",
  mainPassengerMobileNumber: "",
  mainPassengerGender: "",
  extraBedCount: 0,
  childCount: 0,
  infantCount: 0,
  roomId: ""
};
export const otherPassengersInfoDefault = {
  mainPassengerName: "",
  mainPassengerFamily: "",
  mainPassengerGender: "",
  roomId: "",
  age: 0,
  roomIndex: 0
};

export const shoppingDefault = {
  purchaserName: "",
  purchaserFamily: "",
  purchaserEmail: "",
  isPurchaserSupervisor: false,
  supervisorName: "",
  supervisorFamily: "",
  supervisorMobileNumber: "",
  supervisorEmail: "",
  purchaserMobileNumber: "",
  requisition: "",
  passengerInfo: [] as Array<typeof passengerInfoDefault>,
  otherPassengersInfo: [] as Array<typeof otherPassengersInfoDefault>
};

export const tourBookingDefault = {
  buyer: {
    mobileNumber: "",
    firstName: "",
    lastName: ""
  },
  roomGuest: [{ passengers: [] }],
  userDescription: ""
};

interface BuyerInfo {
  notifierType?: string;
  phoneNumber?: string;
  receiverPhoneNumber?: string;
  // fullName?: string;
  email?: string;
  receiverEmail?: string;
}

export type IntlFlightsPassengerStore = {
  buyerInfo?: BuyerInfo;
  passengers?: Array<{
    passengerType: string;
    passengerData: PassengerStoreType;
  }>;
};

export type DomFlightsPassengerStore = {
  buyerInfo?: BuyerInfo;
  passengers?: Array<{
    passengerType: string;
    passengerData: PassengerStoreType;
  }>;
};

export type BusPassengerStore = {
  passengers?: Array<PassengerStoreType>;
  selectedSeats: Array<number>;
};

const flightsIntlBookingDefault: IntlFlightsPassengerStore = {
  buyerInfo: {},
  passengers: []
};

const flightsDomBookingDefault: DomFlightsPassengerStore = {
  buyerInfo: {},
  passengers: []
};
const busBookingDefault: BusPassengerStore = {
  passengers: [],
  selectedSeats: []
};
const applicationDataDefault = {
  isPwa: false,
  appVersion: ""
};
export const applicationStore = observable({
  shopping: shoppingDefault,
  tourBooking: tourBookingDefault,
  flightsIntlBooking: flightsIntlBookingDefault,
  flightsDomBooking: flightsDomBookingDefault,
  busBooking: busBookingDefault,
  safarmarket: false,
  bankName: "saman",
  applicationData: applicationDataDefault,
  channelTemporary: ""
});

persistObservable(applicationStore, {
  local: "application_store",
  pluginLocal: ObservablePersistSessionStorage
});
